import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoShare = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Share</title>
    <path
      d="M5.143 21.559v4.57a2.286 2.286 0 0 0 2.286 2.287H24.57a2.286 2.286 0 0 0 2.286-2.286v-4.571m-10.856 0v-16m0 0 6.856 6.857M16 5.56l-6.857 6.856"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoShare;
